import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { CreateCreditNoteRequest } from '@atlassian/cssxp-types-billing';

const client = createAxiosClient({ baseURL: '/api/1/invoice' }, ServiceProxyMap.ANS);

type CreateCreditNotesCCPResult = {
  id: string;
  number: string;
  memo: string;
  reason: string;
  invoice: string;
  items: Array<string> | null;
  status: string;
  createdAt: number;
};

export const createCreditNotesCCP = async (
  createCreditNoteRequest: CreateCreditNoteRequest
): Promise<CreateCreditNotesCCPResult | undefined> => {
  const result: { data?: CreateCreditNotesCCPResult } = await client.post('/credit-note', createCreditNoteRequest);
  return result?.data;
};
